import { render, staticRenderFns } from "./Truck.vue?vue&type=template&id=9b8ce674&scoped=true"
import script from "./Truck.vue?vue&type=script&lang=js"
export * from "./Truck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8ce674",
  null
  
)

export default component.exports